<!-- Hero Banner Section with improved loading and animations -->
<div class=" swiper-container px-0 mx-0">
  <div class="swiper-wrapper">
    <div class="skeleton-loader min-h-52 bg-gray-700 animate-pulse" *ngIf="!imageLoaded">
    </div>
    <div class="swiper-slide" *ngFor="let data of banners">
      <div class="swiper-slide flex items-center justify-center">
        <a [href]="data.product_url" class="carousel-image" target="_blank">
          <img [src]="data.image_url" *ngIf="imageLoaded">
        </a>
      </div>
    </div>
  </div>
  <div class="swiper-pagination bottom-10 text-primary"></div>
</div>
<!-- Enhanced Offer Marquee -->
<!-- <div class="offer-marquee bg-gradient-to-r from-primary via-primary-600 to-primary py-3 my-6">
  <div class="marquee-container overflow-hidden">
    <div class="marquee-content flex flex-row animate-marquee" #marqueeContent>
      <span *ngFor="let offer of offers" class="offer-text text-white font-medium whitespace-nowrap px-8 flex items-center">
        <i class="pi pi-star-fill text-yellow-300 mr-2"></i>
        {{ offer }}
        <span class="mx-6 text-white/60">|</span>
      </span>
      <span *ngFor="let offer of offers" class="offer-text text-white font-medium whitespace-nowrap px-8 flex items-center">
        <i class="pi pi-star-fill text-yellow-300 mr-2"></i>
        {{ offer }}
        <span class="mx-6 text-white/60">|</span>
      </span>
    </div>
  </div>
</div> -->


<div class="offer-marquee">
  <div class="marquee-container">
    <div class="marquee-content flex flex-row" #marqueeContent>
      <span *ngFor="let offer of offers" class="offer-text">
        {{ offer }} &nbsp;&nbsp; | &nbsp;&nbsp;
      </span>
      <!-- Duplicate for smooth infinite scrolling -->
      <span *ngFor="let offer of offers" class="offer-text">
        {{ offer }} &nbsp;&nbsp; | &nbsp;&nbsp;
      </span>
    </div>
  </div>
</div>

<!-- Enhanced Shop By Category Section -->
<div class="md:block hidden category-section my-5 px-4 md:px-6 lg:px-8">
  <div class="text-center mb-8">
    <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-2">Shop By Category</h2>
    <div class="w-24 h-1 bg-primary mx-auto rounded-full"></div>
    <p class="text-gray-600 mt-4 max-w-2xl mx-auto">Discover our wide range of categories tailored just for you</p>
  </div>

  <div class="hidden lg:flex md:flex items-center justify-center">
    <div #scrollContainer class="flex w-full justify-center flex-wrap gap-6 lg:gap-8 p-6">
      <div class="category-card group cursor-pointer" *ngFor="let data of category"
        (click)="redirectToProduct(data.id)">

        <div
          class="flex flex-col items-center p-6 bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 min-w-[140px]">
          <!-- Icon container with enhanced styling -->
          <div class="icon-container mb-4 relative">
            <div
              class="w-20 h-20 bg-gradient-to-br from-secondary to-secondary/80 rounded-2xl flex items-center justify-center shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:rotate-3">
              <img class="w-12 h-12 object-contain filter group-hover:scale-110 transition-transform duration-300"
                [src]="data.img" [alt]="data.name">
            </div>
            <!-- Decorative elements -->
            <div
              class="absolute -top-1 -right-1 w-6 h-6 bg-primary rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            </div>
          </div>

          <!-- Category name -->
          <h3
            class="font-bold text-gray-800 text-center text-sm md:text-base group-hover:text-primary transition-colors duration-300">
            {{data.name}}
          </h3>

          <!-- Hover indicator -->
          <div class="w-0 h-0.5 bg-primary group-hover:w-full transition-all duration-300 mt-2 rounded-full"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Mobile category scroll (visible on mobile) -->
  <!-- <div class="flex lg:hidden md:hidden overflow-x-auto gap-4 px-4 pb-4 scrollbar-hide">
    <div class="category-card-mobile flex-shrink-0" *ngFor="let data of category" (click)="redirectToProduct(data.id)">
      <div class="flex flex-col items-center p-4 bg-white rounded-xl shadow-md min-w-[100px]">
        <div class="w-16 h-16 bg-secondary rounded-xl flex items-center justify-center mb-3">
          <img class="w-10 h-10 object-contain" [src]="data.img" [alt]="data.name">
        </div>
        <h3 class="font-semibold text-gray-800 text-xs text-center">{{data.name}}</h3>
      </div>
    </div>
  </div> -->
</div>

<!-- Enhanced Bestsellers Section -->
<div class="w-full flex justify-center bg-gray-50 py-10">
  <div class="main-b-container  mx-auto">
    <div class="text-center mb-8">
      <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-2">Bestsellers</h2>
      <div class="w-24 h-1 bg-primary mx-auto rounded-full"></div>
      <p class="text-gray-600 mt-4">Our most popular products loved by customers</p>
    </div>

    <app-category-listing [cardLoaded]="featuringCardLoaded" [cardsData]="featuringData" backgroundColor="#ffffff"
      [title]="''">
    </app-category-listing>
  </div>
</div>

<!-- Video Carousel with enhanced styling -->
<!-- <div class="video-section py-8">
  <app-video-carousel></app-video-carousel>
</div> -->

<!-- Enhanced Customer Testimonials -->
<div class="testimonials-section py-16 bg-gradient-to-br from-primary to-primary-700 relative overflow-hidden">
  <!-- Background decorative elements -->
  <div class="absolute top-0 left-0 w-64 h-64 bg-white opacity-5 rounded-full -translate-x-32 -translate-y-32"></div>
  <div class="absolute bottom-0 right-0 w-96 h-96 bg-white opacity-5 rounded-full translate-x-48 translate-y-48"></div>

  <div class="container mx-auto px-4 relative z-10">
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold text-white mb-4">What Our Customers Say</h2>
      <div class="w-24 h-1 bg-white mx-auto rounded-full opacity-80"></div>
      <p class="text-white/80 mt-4 max-w-2xl mx-auto">Real feedback from real customers who love our products</p>
    </div>

    <div class="card">
      <p-carousel [value]="feedback" [numVisible]="3" [numScroll]="3" [circular]="true"
        [responsiveOptions]="responsiveOptions" [autoplayInterval]="2000">
        <ng-template let-data pTemplate="item">
          <div
            class="feedback-card bg-white/10 backdrop-blur-sm text-white min-w-80 max-w-sm  p-8 rounded-2xl shadow-xl border border-white/20 hover:bg-white/15 transition-all duration-300">

            <!-- Customer info with enhanced styling -->
            <div class="flex items-center mb-6">
              <div class="relative">
                <div class="w-14 h-14 rounded-full overflow-hidden border-3 border-white/30 shadow-lg">
                  <img *ngIf="data.profile_photo" [src]="data.profile_photo" [alt]="data.customer_name"
                    class="w-full h-full object-cover">
                  <div *ngIf="!data.profile_photo" class="w-full h-full bg-white/20 flex items-center justify-center">
                    <i class="pi pi-user text-xl text-white/70"></i>
                  </div>
                </div>
                <!-- Online indicator -->
                <div class="absolute -bottom-1 -right-1 w-4 h-4 bg-green-400 rounded-full border-2 border-white"></div>
              </div>

              <div class="ml-4 flex-1">
                <h4 class="font-semibold text-white text-lg">{{ data.customer_name }}</h4>
                <div class="flex items-center mt-1">
                  <div class="review-rating flex">
                    <ng-container *ngFor="let i of [1, 2, 3, 4, 5]">
                      <i class="pi pi-star-fill text-yellow-300 text-sm mr-1" *ngIf="i <= data.rating"></i>
                      <i class="pi pi-star text-white/40 text-sm mr-1" *ngIf="i > data.rating"></i>
                    </ng-container>
                  </div>
                  <span class="text-white/60 text-sm ml-2">({{ data.rating }}/5)</span>
                </div>
              </div>
            </div>

            <!-- Review content -->
            <div class="mb-4">
              <h5 class="font-bold text-white text-lg mb-3">{{ data.title }}</h5>
              <p class="text-white/90 leading-relaxed text-sm">"{{ data.description }}"</p>
            </div>

            <!-- Quote decoration -->
            <div class="absolute top-4 right-6 text-white/20 text-4xl font-serif">"</div>
          </div>
        </ng-template>
      </p-carousel>
    </div>

    
  </div>
</div>

<!-- Enhanced Blog Section -->
<div class="blog-section py-16 bg-white">
  <div class="container mx-auto px-4 max-w-7xl">
    <div class="flex justify-between items-center mb-8">
      <div>
        <h2 class="text-3xl md:text-4xl font-bold text-gray-800 mb-2">Read Our Blogs</h2>
        <div class="w-24 h-1 bg-primary rounded-full"></div>
        <p class="text-gray-600 mt-4">Stay updated with the latest trends and insights</p>
      </div>
      <a routerLink="/blogs"
        class="hidden md:flex items-center text-primary font-semibold hover:text-primary-600 transition-colors group">
        View All
        <i class="pi pi-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
      </a>
    </div>

    <!-- Blog cards with enhanced design -->
    <div class="flex flex-nowrap overflow-x-auto gap-6 pb-6 scrollbar-hide">
      <article *ngFor="let data of blogList"
        class="blog-card flex-shrink-0 w-80 bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden">

        <!-- Image with overlay -->
        <div class="relative overflow-hidden h-48">
          <img [src]="data.images[0]" alt="Blog image"
            class="w-full h-full object-cover transition-transform duration-500 hover:scale-110">
          <div class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>

          <!-- Category badge -->
          <div class="absolute top-4 left-4">
            <span class="bg-primary text-white px-3 py-1 rounded-full text-sm font-medium">
              {{data.category}}
            </span>
          </div>
        </div>

        <!-- Content -->
        <div class="p-6">
          <h3 class="text-xl font-bold text-gray-800 mb-3 line-clamp-2 hover:text-primary transition-colors">
            {{data.title}}
          </h3>

          <a [routerLink]="['/blogs', data.id]"
            class="inline-flex items-center text-primary font-semibold hover:text-primary-600 transition-colors group">
            Read More
            <i class="pi pi-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </article>
    </div>

    <!-- Mobile view all button -->
    <div class="md:hidden text-center mt-6">
      <a routerLink="/blogs"
        class="inline-flex items-center text-primary font-semibold hover:text-primary-600 transition-colors">
        View All Blogs
        <i class="pi pi-arrow-right ml-2"></i>
      </a>
    </div>
  </div>
</div>

<!-- Enhanced Accreditations Section -->
<div class="accreditations-section py-16 bg-gray-50">
  <div class="container mx-auto px-4">
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold text-primary mb-4">Our Accreditations</h2>
      <div class="w-24 h-1 bg-primary mx-auto rounded-full"></div>
      <p class="text-gray-600 mt-4 max-w-2xl mx-auto">Trusted by industry leaders and certified by top organizations</p>
      <app-infinite-scroller>
        <ng-container *ngFor="let data of mashhoorplusImages">
          <img style="mix-blend-mode: difference;" class="h-24 w-24 rounded-full transition-all duration-300"
            [src]="data.data" [alt]="data.name">
        </ng-container>
      </app-infinite-scroller>
    </div>

  </div>
</div>